var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14916_180)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 14,
    r: 20,
    fill: "#00B8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8252 5.00002C11.8664 4.99772 10.9215 5.2219 10.0654 5.6538C7.97536 6.69837 6.6519 8.83701 6.65051 11.1735C6.64828 12.0302 6.85301 12.8665 7.19893 13.6477L6.03355 17.1438C5.99524 17.2584 5.98962 17.3814 6.01732 17.499C6.04502 17.6166 6.10496 17.7242 6.19039 17.8096C6.27583 17.895 6.38338 17.955 6.50098 17.9827C6.61859 18.0104 6.74158 18.0048 6.85617 17.9664L10.3523 16.8011C11.1335 17.147 11.9698 17.3517 12.8265 17.3495C15.162 17.3481 17.2999 16.0257 18.3449 13.9371V13.9358C18.7775 13.079 19.0025 12.1333 19 11.1735V10.8498C18.9999 10.8379 18.9994 10.8261 18.9987 10.8142C18.826 7.68365 16.3163 5.174 13.1858 5.00129C13.1739 5.00054 13.1621 5.00012 13.1502 5.00002H12.8265H12.8252ZM12.8239 6.29996C12.8244 6.29996 12.8248 6.29996 12.8252 6.29996H13.1198C15.5951 6.43924 17.5608 8.40486 17.7 10.8802V11.1748C17.7 11.1752 17.7 11.1756 17.7 11.1761C17.702 11.9316 17.5253 12.6776 17.1846 13.3519C17.1842 13.3528 17.1838 13.3536 17.1833 13.3545C16.3575 15.007 14.6727 16.0488 12.8252 16.0495C12.8248 16.0495 12.8244 16.0495 12.8239 16.0495C12.0684 16.0515 11.3224 15.8748 10.6481 15.5341C10.5715 15.4954 10.4879 15.4721 10.4023 15.4658C10.3167 15.4595 10.2307 15.4702 10.1492 15.4973L7.67879 16.3212L8.50268 13.8508C8.5298 13.7693 8.54051 13.6833 8.53419 13.5977C8.52787 13.512 8.50465 13.4285 8.46587 13.3519C8.12523 12.6775 7.94849 11.9315 7.95046 11.176C7.95046 11.1756 7.95046 11.1752 7.95046 11.1748C7.95117 9.32732 8.99302 7.64255 10.6456 6.81664C10.6464 6.81622 10.6473 6.8158 10.6481 6.81537C11.3225 6.47474 12.0684 6.29799 12.8239 6.29996Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14916_180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 11.2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentOpen);
export default __webpack_public_path__ + "static/media/CommentOpen.a8de9934c32432dae1074eccaa2f29bd.svg";
export { ForwardRef as ReactComponent };